import styled, { css } from 'styled-components';
import { mq, getGridSpans, getSpace, getColor, maxContentWidth } from '../../../stylesheets/tools';
import { myFuturiumMap } from '../../../helper';

const StyledExhibitionTeaser = styled.div`
  position: relative;
  overflow: hidden;
  ${maxContentWidth('1440px')}
  width: 100%;
  margin: ${getSpace('120px')} auto ${getSpace('xxl')};
  display: flex;
  align-items: center;
  flex-direction: column;

  ${mq('l')} {
    flex-direction: row;
    min-height: 550px;
    margin-top: ${props => !props.uri && getSpace('240px')};
  }

  ${props =>
    props.uri &&
    css`
      min-height: 500px;

      ${mq('l')} {
        min-height: 600px;
      }

      ${mq('xl')} {
        min-height: 916px;
      }
    `}
  .exhibitionTeaser__background {
    position: absolute;
    width: 1280px;
    height: 814px;
    bottom: 0;
    right: 0;
    transform: scaleX(-1);

    ${mq('l')} {
      width: 1440px;
      height: 916px;
      bottom: auto;
    }
  }

  .exhibitionTeaser__headlines {
    ${getGridSpans('width', { s: 12, m: 5, l: 5 })};
    ${getGridSpans('margin-left', { m: [1, 'full'], l: [0] })};
    color: ${getColor('white')};

    ${mq('l')} {
      padding-left: ${getSpace('m')};
    }
  }

  .exhibitionTeaser__headlines h2 {
    color: ${props => props.slug && myFuturiumMap(props.slug, 'color')};
  }

  .exhibitionTeaser__headlines span {
    margin-bottom: ${getSpace('xxs')};
  }

  .exhibtionTeaser__image {
    ${getGridSpans('width', { s: 12, m: 12, l: [6, 'full'] })};
    position: relative;
    margin-bottom: ${getSpace('m')};
    padding: 0 ${getSpace('24px')};

    ${mq('m')} {
      padding: 0 ${getSpace('46px')};
    }

    ${mq('l')} {
      position: absolute;
      margin-bottom: 0;
      padding: 0;
      right: 0;
    }

    ${props =>
      !props.uri &&
      css`
        ${getGridSpans('width', { s: 12, m: 12, l: [8, 'full'] })};
      `}
  }

  .exhibtionTeaser__image-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .exhibtionTeaser__copy {
    ${getGridSpans('width', { s: 11, m: 8, l: [5, 'full'] })};
    ${getGridSpans('margin-left', { s: 1, m: [2, 'full'], l: [1, 'full'] })};
    margin-bottom: ${getSpace('m')};
    color: ${getColor('white')};

    ${mq('l')} {
      margin-bottom: 0;
      padding-left: ${getSpace('m')};
    }

    ${props =>
      !props.uri &&
      css`
        ${getGridSpans('margin-left', { s: 1, m: [2, 'full'], l: [0] })};
      `}
  }

  .exhibtionTeaser__label {
    display: flex;
    align-items: center;

    svg {
      margin-right: ${getSpace('xxs')};
    }
  }

  &:nth-child(even) {
    .exhibitionTeaser__headlines {
      ${getGridSpans('margin-left', { l: [6, 'full'] })};
    }

    .exhibtionTeaser__copy {
      ${getGridSpans('margin-left', { l: [7, 'full'] })};
    }

    .exhibitionTeaser__background {
      transform: scaleX(1);
      left: 0;
    }

    .exhibtionTeaser__image {
      ${mq('l')} {
        left: 0;
      }
    }
  }
`;

export default StyledExhibitionTeaser;
